import { useRowSelectionContext } from "../context/RowSelectionContext";

export const useRowSelection = () => {
  const { store } = useRowSelectionContext();

  return {
    getSelection: store.getSelection,
    clear: store.clear,
    toggle: store.toggle,
  };
};
